module.exports = __webpack_public_path__ + "img/classicdrawing@2x.1d0167a.webp";